import React from "react";
import KendoDropdown from "../../../components/form/KendoDropdown";
import { useFetchPayers } from "./hooks/useFetchPayers";

export default function PayerDropdown({ selectedPayer, setSelectedPayer }) {
  const { data: payerDataSource = [], isLoading } = useFetchPayers();
  return (
    <KendoDropdown
      dataSource={payerDataSource || []}
      textField="label"
      idField="value"
      value={selectedPayer}
      loading={isLoading}
      onChange={(e) => {
        setSelectedPayer(e);
      }}
    />
  );
}
